import { Sondaggio } from '@hm_app/@core/models/alerts';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class AlertQuesitoService {

    // Observable sources
    private alertQuesito = new BehaviorSubject<Sondaggio>(null);

    // Observable streams
    alertQuesitoObservable = this.alertQuesito.asObservable();

    // Service message commands
    passAlertQuesito(alertQuesito: Sondaggio) {
        this.alertQuesito.next(alertQuesito);
        // console.log(this.alertQuesito)
    }
}
